<template>
  <div>
    <div v-for="(item, idx) in items" :key="`item-${idx}`">
      <modal :name="item.modal_name" :adaptive="true" height="auto" class="modal-style">
        <div class="lp-modal-wrapper">
          <div class="title" style="margin-bottom:1.5rem !important;">{{ item.title }}</div>
          <div class="content">{{ item.content }}</div>
          <div class="tip">{{ item.tip }}</div>
          <div class="btn-group-justify-end">
            <button class="button"
                    v-if="item.modal_name.indexOf('-Success')===-1"
                    @click="$modal.hide(item.modal_name)">취소
            </button>
            <button class="button is-primary" @click="confirm(item)">확인</button>
          </div>
        </div>
      </modal>
    </div>
  </div>
</template>

<script>
  export default {
    name: "ModalConfirm",
    props: {
      count: {
        type: Number,
        default: 1
      }
    },
    computed: {
      items () {
        return [
          {
            modal_name: '입금완료',
            title: '입금완료 처리',
            content: `${this.count}건의 주문을 입금완료 처리 하시겠습니까?`,
          },
          {
            modal_name: '입금완료-Success',
            title: '입금완료 처리 완료',
            content: `${this.count}건의 주문이 입금완료 처리되어 신규 주문 현황에서 조회 가능합니다.`,
          },
          {
            modal_name: '주문확정',
            title: '주문확정 처리',
            content: `선택한 ${this.count}건의 주문확정 처리 하시겠습니까?`
          },
          {
            modal_name: '주문확정-Success',
            title: '주문확정 처리 완료',
            content: `${this.count}건의 주문이 확정 처리되어 주문확정 내역에서 조회 가능합니다.`
          },
          {
            modal_name: '상품준비중',
            title: '상품준비중 처리',
            content: `선택한 ${this.count}건의 상품준비중 처리 하시겠습니까?`
          },
          {
            modal_name: '상품준비중-Success',
            title: '상품준비중 처리 완료',
            content: `${this.count}건의 상품 준비중 처리되어 상품준비중 내역에서 조회 가능합니다.`
          },
          {
            modal_name: '배달대기',
            title: '배달대기 처리',
            content: `선택한 ${this.count}건의 배달대기 처리 하시겠습니까?`
          },
          {
            modal_name: '배달대기-Success',
            title: '배달대기 처리 완료',
            content: `${this.count}건의 배달이 대기 처리되어 배달대기 내역에서 조회 가능합니다.`
          },
          {
            modal_name: '배달중',
            title: '배달중 처리',
            content: `선택한 ${this.count}건의 배달중 처리 하시겠습니까?`
          },
          {
            modal_name: '배달중-Success',
            title: '배달중 처리 완료',
            content: `${this.count}건의 배달중 처리되어 배달중 내역에서 조회 가능합니다.`
          },
          {
            modal_name: '배달완료',
            title: '배달완료 처리',
            content: `선택한 ${this.count}건의 배달완료 처리 하시겠습니까?`
          },
          {
            modal_name: '배달완료-Success',
            title: '배달완료 처리 완료',
            content: `${this.count}건의 배달완료 처리되어 배달완료 내역에서 조회 가능합니다.`
          },
          {
            modal_name: '구매확정',
            title: '구매확정 처리',
            content: `선택한 ${this.count}건의 주문을 확정 처리 하시겠습니까?`
          },
          {
            modal_name: '구매확정-Success',
            title: '구매확정 처리 완료',
            content: `${this.count}건의 구매확정 처리되어 구매확정 내역에서 조회 가능합니다.`
          },
          {
            modal_name: '취소요청',
            title: '취소요청 처리',
            content: `선택한 ${this.count}건의 취소요청 처리 하시겠습니까?`,
            tip: '※ 무통장입금으로 주문되어 환불이 필요한 주문 취소 건은 \'취소 요청 내역\'에서 환불처리 해주시기 바랍니다.'
          },
          {
            modal_name: '취소요청-Success',
            title: '취소요청 처리 완료',
            content: `${this.count}건의 취소요청 처리되어 취소요청 내역에서 조회 가능합니다.`
          },
          {
            modal_name: '취소승인',
            title: '취소승인 처리',
            content: `선택한 ${this.count}건의 취소승인 처리 하시겠습니까?`
          },
          {
            modal_name: '취소승인-Success',
            title: '취소승인 처리 완료',
            content: `${this.count}건의 취소승인 처리되어 취소승인 내역에서 조회 가능합니다.`
          },
          {
            modal_name: '취소보류',
            title: '취소보류 처리',
            content: `선택한 ${this.count}건의 취소보류 처리 하시겠습니까?`
          },
          {
            modal_name: '취소보류-Success',
            title: '취소보류 처리 완료',
            content: `${this.count}건의 취소보류 처리되어 전체 주문취소/결제취소 내역에서 조회 가능합니다.`
          },
          {
            modal_name: '취소보류',
            title: '취소보류 처리',
            content: `선택한 ${this.count}건의 취소보류 처리 하시겠습니까?`
          },
          {
            modal_name: '취소보류-Success',
            title: '취소보류 처리 완료',
            content: `${this.count}건의 취소보류 처리되어 전체 주문취소/결제취소 내역에서 조회 가능합니다.`
          },

          {
            modal_name: '취소완료(입급전 주문취소)',
            title: '취소완료(입급전 주문취소) 처리',
            content: `선택한 ${this.count}건의 취소완료(입급전 주문취소) 처리 하시겠습니까?`
          },
          {
            modal_name: '취소완료(입급전 주문취소)-Success',
            title: '취소완료(입급전 주문취소) 처리 완료',
            content: `${this.count}건의 취소완료(입급전 주문취소) 처리되어 전체 주문취소/결제취소 내역에서 조회 가능합니다.`
          },
          {
            modal_name: '취소완료(환불 완료)',
            title: '취소완료(환불 완료) 처리',
            content: `선택한 ${this.count}건의 취소완료(환불 완료) 처리 하시겠습니까?`
          },
          {
            modal_name: '취소완료(환불 완료)-Success',
            title: '취소완료(환불 완료) 처리 완료',
            content: `${this.count}건의 취소완료(환불 완료) 처리되어 전체 주문취소/결제취소 내역에서 조회 가능합니다.`
          },
          {
            modal_name: '반품요청(승인대기)',
            title: '반품요청(승인대기) 처리',
            content: `선택한 ${this.count}건의 반품요청(승인대기) 처리 하시겠습니까?`
          },
          {
            modal_name: '반품요청(승인대기)-Success',
            title: '반품요청(승인대기) 처리 완료',
            content: `${this.count}건의 반품요청(승인대기) 처리되어 전체 반품요청 내역에서 조회 가능합니다.`
          },
          {
            modal_name: '반품처리중(수거진행)',
            title: '반품처리중(수거진행) 처리',
            content: `선택한 ${this.count}건의 반품처리중(수거진행) 처리 하시겠습니까?`
          },
          {
            modal_name: '반품처리중(수거진행)-Success',
            title: '반품처리중(수거진행) 처리 완료',
            content: `${this.count}건의 반품처리중(수거진행) 처리되어 전체 반품요청 내역에서 조회 가능합니다.`
          },
          {
            modal_name: '반품검사중',
            title: '반품검사중 처리',
            content: `선택한 ${this.count}건의 반품검사중 처리 하시겠습니까?`
          },
          {
            modal_name: '반품검사중-Success',
            title: '반품검사중 처리 완료',
            content: `${this.count}건의 반품검사중 처리되어 전체 반품검사중 내역에서 조회 가능합니다.`
          },
          {
            modal_name: '반품검사완료(환불대기)',
            title: '반품검사완료(환불대기) 처리',
            content: `선택한 ${this.count}건의 반품검사완료(환불대기) 처리 하시겠습니까?`
          },
          {
            modal_name: '반품검사완료(환불대기)-Success',
            title: '반품검사완료(환불대기) 처리 완료',
            content: `${this.count}건의 반품검사완료(환불대기) 처리되어 전체 반품 검사 완료 내역에서 조회 가능합니다.`
          },
          {
            modal_name: '반품검사완료(환불보류)',
            title: '반품검사완료(환불보류) 처리',
            content: `선택한 ${this.count}건의 반품검사완료(환불보류) 처리 하시겠습니까?`
          },
          {
            modal_name: '반품검사완료(환불보류)-Success',
            title: '반품검사완료(환불보류) 처리 완료',
            content: `${this.count}건의 반품검사완료(환불보류) 처리되어 전체 반품요청 내역에서 조회 가능합니다.`
          },
          {
            modal_name: '반품완료(환불완료)',
            title: '반품완료(환불완료) 처리',
            content: `선택한 ${this.count}건의 반품완료(환불완료) 처리 하시겠습니까?`
          },
          {
            modal_name: '반품완료(환불완료)-Success',
            title: '반품완료(환불완료) 처리 완료',
            content: `${this.count}건의 반품완료(환불완료) 처리되어 전체 환불완료 목록에서 조회 가능합니다.`
          },
          {
            modal_name: '주문취소',
            title: '주문 취소 처리',
            content: `${this.count}건의 주문을 취소 처리 하시겠습니까?`
          },
          {
            modal_name: '주문취소-Success',
            title: '주문 취소 처리 완료',
            content: `${this.count}건의 주문이 취소 처리 완료 되었습니다.`,
            tip: '※ 무통장입금으로 주문되어 환불이 필요한 주문 취소 건은 \'취소 요청 내역\'에서 환불처리 해주시기 바랍니다.'
          }
        ]
      }
    },
    methods: {
      confirm(item) {
        if (item.modal_name.indexOf('-Success') > -1) {
          this.$emit('closeModal', item.modal_name);
        } else {
          this.$modal.hide(item.modal_name);
          this.$emit('confirm', item.modal_name);
        }
      }
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>
  .tip
    white-space pre-line
</style>
